export default function STMark({ className = '', size = 28, variant = 'icon' }) {
  if (variant === 'icon') {
    return (
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} aria-label="SomosTorre">
        <rect width="40" height="40" rx="10" fill="currentColor" />
        <text
          x="20" y="28"
          textAnchor="middle"
          fontFamily="'DM Sans', system-ui, sans-serif"
          fontWeight="800"
          fontSize="26"
          fill="white"
        >
          T
        </text>
      </svg>
    );
  }

  // variant === 'mark' — just the letter, no background
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} aria-label="SomosTorre">
      <text
        x="20" y="30"
        textAnchor="middle"
        fontFamily="'DM Sans', system-ui, sans-serif"
        fontWeight="800"
        fontSize="28"
        fill="currentColor"
      >
        T
      </text>
    </svg>
  );
}
